import { ReactElement } from 'react';
import { useUITranslation } from '../../hooks';
import { UIText } from '..';
import { UIButton, UISpinner } from '../..';
import { charcoal } from '../../styles';

export type UILoadingStateProps = {
    text?: string;
};
export function UILoadingState(props: UILoadingStateProps): ReactElement {
    const { t } = useUITranslation();
    const { text = t('components.ui_state.loading') } = props;
    return (
        <div
            style={{
                display: 'flex',
                flex: 1,
                gap: 8,
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <UISpinner color={charcoal} />
            <UIText>{text}</UIText>
        </div>
    );
}

type UIErrorStateProps = {
    title: string;
    onRetry?: () => void;
};
export function UIErrorState(props: UIErrorStateProps): ReactElement {
    const { t } = useUITranslation();
    const { title, onRetry } = props;
    return (
        <div
            style={{
                display: 'flex',
                flex: 1,
                gap: 8,
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <UIText>{title}</UIText>
            {onRetry && (
                <UIButton onClick={onRetry}>
                    {t('components.ui_state.retry')}
                </UIButton>
            )}
        </div>
    );
}

type UIEmptyStateProps = {
    title?: string;
    description?: string;
    emoji?: string;
    buttonText?: string;
    onClick?: () => void;
};

export function UIEmptyState(props: UIEmptyStateProps): ReactElement {
    const { title, emoji, description, buttonText, onClick } = props;
    return (
        <div
            style={{
                display: 'flex',
                flex: 1,
                gap: 8,
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            {emoji && <span style={{ fontSize: '3rem' }}>{emoji}</span>}
            {/* UIText defaults to left-aligned, which shows up as soon as a
                title or description is long enough to wrap. */}
            {title && (
                <UIText variant="h2" textAlign="center">
                    {title}
                </UIText>
            )}
            {description && <UIText textAlign="center">{description}</UIText>}
            {onClick && <UIButton onClick={onClick}>{buttonText}</UIButton>}
        </div>
    );
}
